import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

import { eventBus } from "../../../../components/ajonjolib/toasts/toast/toast";
import Modal from "../../../../components/ajonjolib/modal/modal/modal";
import axiosInstance from "../../../../AxiosInstance";

const ResetAllModal = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pduiId, setPduiId] = useState(null);

  useEffect(() => {
    eventBus.subscribe("reset_all_open", (rec_data) => {
      console.log("reset_all_open", rec_data);
      setIsOpen(true);
      setPduiId(rec_data.pduiId);
    });
    eventBus.subscribe("reset_all_close", () => {
      setIsOpen(false);
    });
  }, []);

  const onClick = async () => {
    if (pduiId && !loading) {
      setLoading(true);
      try {
        await axiosInstance.put(`pdui/${pduiId}/reset_all/`);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
        setIsOpen(false);
      }
    }
  };

  return (
    <div>
      {isOpen && (
        <Modal close={() => setIsOpen(false)}>
          <div className={"d-flex flex-column justify-content-center my-3"}>
            <h3 className={"text-dark"}>{t('resetAll.title')}</h3>
            <p className={"fs-6"}>
              {t('resetAll.confirm')}
            </p>
            <div className={"d-flex justify-content-center gap-4"}>
              <button
                className={"btn text-light"}
                style={{
                  backgroundColor: loading ? "#d4d4d4" : "#66CC66",
                  cursor: loading ? "not-allowed" : "pointer",
                }}
                onClick={onClick}
              >
                {t('resetAll.yes')}
              </button>
              <button
                className={"btn btn-danger"}
                onClick={() => setIsOpen(false)}
              >
                {t('resetAll.no')}
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default ResetAllModal;
